<template src="@/templates/account/staffLogin.html"></template>

<script>
import LoginModel from "@/models/loginModel";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import { VueContext } from "vue-context";
import { profileInterpreterMixin } from "@/mixins/profiles/interpreter";

export default {
  name: "staffLogin",
  components: { LoginModel, VueContext },
  data() {
    return {
      loginModel: new LoginModel(),
      staffLoginData: {
        user: "",
        pass: "",
        intID: "",
      },
      loginError: false,
      popupActive: false,
      errorMessage: "",
    };
  },
  computed: {
    ...mapGetters(["isBookingsConfirmed"]),
    title() {
      return "STAFF LOGIN";
    },
  },
  watch: {
    isBookingsConfirmed: {
      handler: function () {
        this.fetchInterpreterProfile;
      },
      deep: true,
    },
  },
  mixins: [validationMixin, profileInterpreterMixin],
  validations: {
    staffLoginData: {
      user: {
        required,
      },
      pass: {
        required,
      },
      intID: {
        required,
      },
    },
  },
  created: function () {
    if (this.isAuthenticated) {
      this.$router.push({ path: "profile" });
    }
  },
  methods: {
    ...mapActions(["updateToken", "checkJobMatchConditions"]),
    loginForm() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }

      this.loginModel
        .save({
          url:
            this.$interpretersApiUrl + this.loginModel.getRoute("staffLogin"),
          data: {
            user: this.staffLoginData.user,
            pass: this.staffLoginData.pass,
            intID: this.staffLoginData.intID,
          },
        })
        .then((res) => {
          let response = res.response.data;

          console.log(this.loginModel.attributes.message);
          this.errorMessage = this.loginModel.attributes.message;

          if (!response) {
            this.loginError = true;
            return;
          }

          if (response.error) {
            this.loginError = true;
            return;
          }

          if (this.loginModel.data.error === false) {
            this.popupActive = true;
          } else {
            this.loginError = true;
          }

          if(!this.loginError) {
            localStorage.setItem("staffLoginToken", response.data.staffLoginToken);
          }

        })
        .catch((error) => {
          console.error(error);
          debugger;
        });
    },
    staffIntLogin() {
      this.loginModel
        .save({
          url:
            this.$interpretersApiUrl +
            this.loginModel.getRoute("staffInterpreterLogin"),
          headers: {
            bearer: localStorage.getItem("staffLoginToken"),
          },
          data: {
            intID: this.staffLoginData.intID,
          },
        })
        .then((res) => {
          let response = res.response.data;
          if (!response) {
            this.loginError = true;
            return;
          }

          if (response.error) {
            this.loginError = true;
          }

          if (response.data.token) {
            localStorage.setItem("staffLogin", this.staffLoginData.user);

            this.popupActive = false;
            localStorage.setItem("jwt", response.data.token);

            /**Update jwt in store*/
            this.updateToken(response.data.token);

            /**Check Confirmed Job within +- 30mins timestamp from now and re-direct to current confirmed bookings if exist else profile**/
            /** Old Logic **/
            // this.checkJobMatchConditions()

            /** New Logic **/
            this.fetchInterpreterProfile;
          } else {
            this.loginError = true;
          }
        })
        .catch((error) => {
          console.error(error);
          debugger;
        });
    },
  },
};
</script>
